module.exports = __webpack_public_path__ + "img/whatsapp.c4fd9b4c.png";